frappe.ui.form.ControlAttach = class ControlAttach extends frappe.ui.form.ControlData {
	make_input() {
		let me = this;
		this.$input = $('<button class="btn btn-default btn-sm btn-attach">')
			.text(__("Attach"))
			.prependTo(me.input_area)
			.on({
				click: function () {
					me.on_attach_click();
				},
				attach_doc_image: function () {
					me.on_attach_doc_image();
				},
			});
		this.$value = $(
			`<div class="attached-file flex" style="flex-direction: column; gap: 0.5rem;">
				<div class="ellipsis">
				${frappe.utils.icon("link", "sm")}
					<a class="attached-file-link" target="_blank"></a>
				</div>
				<div class="flex" style="align-items: center">
					<a class="btn btn-xs btn-default" data-action="clear_attachment">${__("Clear")}</a>
				</div>
			</div>`
		)
			.prependTo(me.input_area)
			.toggle(false);
		this.input = this.$input.get(0);
		this.set_input_attributes();
		this.has_input = true;

		frappe.utils.bind_actions_with_object(this.$value, this);
	}

	get_preview_section() {
		// @dokos: Automatically try to upgrade Attach to Attach Image
		const is_image = String(this.df.fieldname).match(
			/image|photo|picture|logo|icon|scan|cover/gi
		);
		if (is_image) {
			return frappe.ui.form.ControlAttachImage?.prototype.get_preview_section?.call(this);
		} else {
			return "";
		}
	}

	clear_attachment() {
		let me = this;
		frappe.confirm(__("Are you sure you want to delete the attachment?"), function () {
			if (me.frm) {
				let file_url = me.value || me.get_model_value();
				me.parse_validate_and_set_in_model(null).then(() => {
					me.refresh();
					let save_action = me.frm.doc.docstatus == 1 ? "Update" : "Save";
					me.frm.save(save_action, () => {
						if (!me.frm.is_dirty()) {
							me.frm.attachments.remove_attachment_by_filename(file_url);
						}
					});
				});
			} else {
				me.dataurl = null;
				me.fileobj = null;
				me.set_input(null);
				me.parse_validate_and_set_in_model(null);
				me.refresh();
			}
		});
	}
	on_attach_click() {
		this.set_upload_options();
		this.file_uploader = new frappe.ui.FileUploader(this.upload_options);
	}

	on_attach_doc_image() {
		this.set_upload_options();
		this.upload_options.restrictions.allowed_file_types = [
			"image/jpeg",
			"image/png",
			"image/gif",
			"image/webp",
			"image/svg+xml",
			"image/avif",
			"image/bmp",
			"image/x-icon",
		];
		this.file_uploader = new frappe.ui.FileUploader(this.upload_options);
	}

	parse_df_options() {
		// @dokos
		if (!this.df.options) {
			return {};
		} else if (this.df.options === "Public" || this.df.options === "Private") {
			return {
				make_attachments_public: this.df.options === "Public",
				forced_file_visibility: this.df.options,
			};
		} else if (typeof this.df.options === "object") {
			// Note: df.options will be overridden in WebForm's setup_fields()
			return this.df.options;
		}
		return {};
	}

	set_upload_options() {
		let options = {
			allow_multiple: false,
			on_success: (file) => {
				this.on_upload_complete(file);
			},
			restrictions: {},
		};

		if (this.frm) {
			options.doctype = this.frm.doctype;
			options.docname = this.frm.docname;
			options.fieldname = this.df.fieldname;
			options.make_attachments_public = this.df.make_attachment_public
				? 1
				: this.frm.meta.make_attachments_public;
		}

		Object.assign(options, this.parse_df_options());

		this.upload_options = options;
	}

	set_input(value, dataurl) {
		this.last_value = this.value;
		this.value = value;
		let filename; // @dokos
		if (this.value) {
			// value can also be using this format: FILENAME,DATA_URL
			// Important: We have to be careful because normal filenames may also contain ","
			let file_url_parts = this.value.match(/^([^:]+),(.*)data:(.+)$/); // @dokos
			if (file_url_parts) {
				filename = file_url_parts[1];
				dataurl = file_url_parts[2] + ":" + file_url_parts[3];
			}
			if (this.$input && this.$value) {
				this.$input.toggle(false);
				this.$value
					.toggle(true)
					.find(".attached-file-link")
					.text(filename || this.value) // @dokos
					.attr("href", dataurl || this.value);
			} else {
				this.$wrapper.html(`
					<div class="attached-file flex" style="flex-direction: column; gap: 0.5rem;">
						<div class="ellipsis">
							<i class="uil uil-paperclip"></i>
							<a class="attached-file-link" target="_blank"></a>
						</div>
						${this.get_preview_section()}
					</div>
				`);
				this.$wrapper // @dokos
					.find(".attached-file-link")
					.text(filename || this.value)
					.attr("href", dataurl || this.value);
			}
		} else {
			this.$input?.toggle(true);
			this.$value?.toggle(false);
		}

		if (this.value) {
			// @dokos
			if (this.$value) {
				this.$value
					.find(".attached-file-preview")
					.attr("src", dataurl || this.value)
					.attr("alt", filename || this.value);
			} else if (!this.disabled_preview_section) {
				this.disabled_preview_section = this.$wrapper
					.find(".control-input-wrapper")
					.append(this.get_preview_section());
				this.disabled_preview_section
					.find(".attached-file-preview")
					.attr("src", dataurl || this.value)
					.attr("alt", filename || this.value);
			}
		}
	}

	get_value() {
		return this.value || null;
	}

	async on_upload_complete(attachment) {
		if (this.frm) {
			await this.parse_validate_and_set_in_model(attachment.file_url);
			this.frm.attachments.update_attachment(attachment);
			if (!this.frm.is_new()) {
				this.frm.doc.docstatus == 1 ? this.frm.save("Update") : this.frm.save();
			}
		}
		this.set_value(attachment.file_url);
	}
};
